'use client';

import { ClipboardIcon } from '@radix-ui/react-icons';

import { Separator } from '@/components/ui/separator';
import { Link } from '@/i18n/routing';

interface IContact {
    id: string;
    name: string;
    scondName: string;
    position: string;
    phone: string;
    email: string;
}

export const ContactCard = ({ contact }: { contact: IContact }) => {
    const copyToClipboard = () => {
        const contactInfo = `
            ${contact.name} ${contact.scondName}\nДолжность: ${contact.position}\nТелефон: ${contact.phone}\nEmail: ${contact.email}`.trim();

        try {
            navigator.clipboard
                .writeText(contactInfo)
                .then(() => alert('Контакт скопирован!'))
                .catch((err) => console.error('Ошибка копирования: ', err));
        } catch (error) {
            console.error('Ошибка копирования: ', error);
        }
    };

    return (
        <div>
            <div className="group relative flex flex-col justify-between rounded-md bg-secondary p-3 shadow-lg">
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        copyToClipboard();
                    }}
                    type="button"
                    className="absolute right-0 top-0 cursor-pointer rounded-bl-md rounded-tr-md p-2 text-white hover:bg-primary"
                >
                    <ClipboardIcon className="h-5 w-5" />
                </button>

                <h4 className="mb-2 text-xl font-semibold text-white transition-colors">
                    {contact.name} {contact.scondName}
                </h4>
                <p className="text-sm text-white">{contact.position}</p>
                <Separator className="my-2 bg-foreground/20" />
                <div className="flex items-center justify-between text-sm text-white">
                    <Link href={`tel:${contact.phone.replace(/\D/g, '')}`} hrefLang={'ru-RU'} className="text-primary">
                        {contact.phone}
                    </Link>
                    <Link href={`mailto:${contact.email}`} hrefLang={'ru-RU'} className="text-primary">
                        {contact.email}
                    </Link>
                </div>
            </div>
        </div>
    );
};
